import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full overflow-hidden" data-id="element-181">
      {/* Hero Background Image - Full Section */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/tVvJNjSPVXka4qNkDLi3aj/hero1.jpg)'
    }} data-id="element-182" />

      {/* Optional overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/40 to-transparent" data-id="element-183" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="relative min-h-[510px] py-10 lg:py-16 flex items-center" data-id="element-185">
          {/* Content */}
          <div className="relative z-20 w-full lg:max-w-2xl" data-id="element-186">
            <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6" data-id="element-187">
              Custom Apparel, Screen Printing & Promotional Products in
              LaGrange, Indiana
            </h1>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-188">
              Specializing in screen printing, embroidery, DTG, DTF, laser
              engraving, and custom promotional products for businesses,
              schools, teams, and events across Northeast Indiana.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-189">
              <Button variant="primary" size="lg" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-191" />} data-id="element-190">
                Get a Quote
              </Button>
              <Button variant="outline" size="lg" data-id="element-192">
                Shop Custom Products
              </Button>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-6 text-sm font-semibold text-gray-600" data-id="element-193">
              <div className="flex items-center gap-2" data-id="element-194">
                <div className="w-2 h-2 rounded-full bg-wh-pink" data-id="element-195" />
                In-House Production
              </div>
              <div className="flex items-center gap-2" data-id="element-196">
                <div className="w-2 h-2 rounded-full bg-wh-yellow" data-id="element-197" />
                Fast Turnaround
              </div>
              <div className="flex items-center gap-2" data-id="element-198">
                <div className="w-2 h-2 rounded-full bg-wh-teal" data-id="element-199" />
                Local Indiana Business
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}